import Vue from 'vue'
import Router from 'vue-router'

import IndexUser from './index-user'           // 引入设置路由

import IndexEvent from './index-event'               // 引入活动数据管理路由

import IndexSetting from './index-setting'           // 引入设置路由

import IndexTest from './index-test'                 // 引入测试路由

// 首页框架
const Dome = () => import(/* webpackChunkName: "Dome" */ '@/components/dome.vue')

const section = () => import(/* webpackChunkName: "Dome" */ '@/components/section.vue')

const Index = () => import(/* webpackChunkName: "Index" */ '@/components/index/index.vue')            // 首页框框

const LoginIndex = () => import(/* webpackChunkName: "LoginIndex" */ '@/components/login/index.vue')  // 登录页面

const edit = () => import(/* webpackChunkName: "Dome" */ '@/components/edit.vue')

const TemplatePreview = () => import(/* webpackChunkName: "TemplatePreview" */ '@/components/curriculum/template-preview.vue')
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/Login'
    },
    // 登录
    {
      path: '/Login',
      component: LoginIndex,
      name: 'LoginIndex'
    },
    {
      path: '/Index',
      name: 'Index',
      component: Index,
      children: [
        ...IndexUser,
        ...IndexEvent,         // 活动数据管理路由
        ...IndexSetting,       // 设置路由
        ...IndexTest,
        {
          path: '/edit',
          name: 'edit',
          component: edit
        }
      ]
    },
    {
      path: '/section',
      name: 'section',
      component: section
    },
    {
      path: '/Dome',
      name: 'Dome',
      component: Dome
    },
    {
      path: '/TemplatePreview',
      name: 'TemplatePreview',
      component: TemplatePreview
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js